// removed by extract-text-webpack-plugin
module.exports = {"icon-button":"iconButton--icon-button--2tXahZtc","iconButton":"iconButton--icon-button--2tXahZtc","isGrey":"iconButton--isGrey--162aav2g","isDisabled":"iconButton--isDisabled--HjV36ahu","icon":"iconButton--icon--1scEVlN6"};


//////////////////
// WEBPACK FOOTER
// ./src/baseComponents/components/Button/iconButton.scss
// module id = 500
// module chunks = 0